import React from 'react';
import { Modal } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { Col, Row } from 'react-bootstrap';
import './SiteModal.scss';

export default function SiteModal(props) {

    const { body, open, onClose, title } = props;

    return (
        <Modal
            open={open}
            onClose={onClose}
            className="site-modal"
            aria-labelledby={title}
            aria-describedby={title + ' Modal'}
        >
            <div className="modal-content">
          <div className="modal-head">
              <Row>
                <Col sm={10}>
                    <h2>{title}</h2>
                </Col>
                <Col sm={2}>
                    <span className="modal-exit" onClick={onClose}><ClearIcon fontSize="large"/></span>
                </Col>
              </Row>
                </div>
                <div className="modal-body-content">
                    {body}
                </div>
            </div>
        </Modal>
    );
}


// WEBPACK FOOTER //
// ./src/components/Common/SiteModal.js